import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'black-accordion-header',
    templateUrl: './accordion-header.component.html',
    styleUrls: ['./accordion-header.component.css'],
    standalone: false
})
export class AccordionHeaderComponent {
  @Input()
  title = '';

  @Input()
  expanded = false;

  @Input()
  index = '';

  @Output()
  toggleEvent: EventEmitter<any> = new EventEmitter();

  @Output()
  deleteEvent: EventEmitter<any> = new EventEmitter();

  fireToggle() {
    this.toggleEvent.emit();
  }

  delete() {
    this.deleteEvent.emit();
  }
}
